module.exports = "/assets/data/a9dc7d8ee2bd737725ee188a05b59534-CH47.data.json";